import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { NotFound } from '../not-found/not-found.js';
import { Audio } from './audio.jsx';
import { Buttons } from './buttons.jsx';
import { Colors } from './colors.jsx';
import { Dials } from './dials.jsx';
import { Gamepad } from './gamepad.jsx';
import { HotKeys } from './hot-keys.jsx';
import { Icons } from './icons.jsx';
import { Inputs } from './inputs.jsx';
import { Manifest } from './manifest.jsx';
import { MultiSelects } from './multi-select.jsx';
import { NotificationStack } from './notification-stack.jsx';
import { Notifications } from './notifications.jsx';
import { PostHog } from './posthog.jsx';
import { Selects } from './selects.jsx';
import { Sliders } from './sliders.jsx';
import { Steppers } from './steppers.jsx';
import { Switches } from './switches.jsx';
import { Tabs } from './tabs.jsx';
import { Tags } from './tag.jsx';
import { Toggles } from './toggles.jsx';
import { UserInvite } from './user-invite/user-invite.js';
import { VideoBadges } from './video-badges.jsx';
import { Wheel } from './wheel.jsx';
import { InviteByLink } from '../exhibits/user-invite/invite-link.jsx';

/** `<Exhibits>` component. */
export const Exhibits = (): ReactElement => (
  <Routes>
    <Route element={<Manifest />} index />
    {/* Individual exhibits */}
    <Route element={<UserInvite />} path='user-invite' />
    <Route element={<MultiSelects />} path='multi-select' />
    <Route element={<Colors />} path='colors' />
    <Route element={<Audio />} path='audio' />
    <Route element={<Tags />} path='tags' />
    <Route element={<Buttons />} path='buttons' />
    <Route element={<Dials />} path='dials' />
    <Route element={<Gamepad />} path='gamepad' />
    <Route element={<HotKeys />} path='hot-keys' />
    <Route element={<Icons />} path='icons' />
    <Route element={<Inputs />} path='inputs' />
    <Route element={<Notifications />} path='notifications' />
    <Route element={<NotificationStack />} path='notification-stack' />
    <Route element={<PostHog />} path='posthog' />
    <Route element={<Selects />} path='selects' />
    <Route element={<Sliders />} path='sliders' />
    <Route element={<Steppers />} path='steppers' />
    <Route element={<Switches />} path='switches' />
    <Route element={<Tabs />} path='tabs' />
    <Route element={<Toggles />} path='toggles' />
    <Route element={<VideoBadges />} path='video-badges' />
    <Route element={<Wheel />} path='wheel' />
    <Route element={<NotFound />} path='*' />
    <Route element={<InviteByLink />} path='invite-by-link' />
  </Routes>
);
